import React, { useEffect } from 'react';
import { CircularProgress, Container, Divider, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChevronLeft, ChevronRight, Lock } from '@material-ui/icons';
import {  useState } from 'react';
import TabPanel from '../Common/TabPanel';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme)=> ({
    container: {
        display: 'flex',
        flex: 1,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        overflowY: 'hidden',
    },
    tab: {
        height: 100,
        width: '100%',
        marginBottom: 8
    },
    innerTab: {
        height: '100%',
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center'
    },
    noLeftCornerRadius: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
    },
    noRightCornerRadius: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
    },
    leftDirection: {
        flexDirection: 'row'
    },
    rightDirection: {
        flexDirection: 'row-reverse'
    },
    center: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: 50
    },
    disabled: {
        backgroundColor: theme.palette.background.default,
        opacity: 0.75,
        zIndex: theme.zIndex.mobileStepper
    }
}))

function HideablePanel(props){
    const classes = useStyles();
    const {t} = useTranslation('common');
    const [isHidden, setIsHidden] = useState(false)
    const [tabValue, setTabValue] = useState(props.tabs[0].value)
    const [widthValue, setWidthValue] = useState('0px');

    const toggleButtonStyles = getToggleButtonStyle(props.position)

    const childrenWithWrapper = React.Children.map(props.children, (child, index)=>{
        return (
            <TabPanel value={tabValue} index={index} style={{height: `calc(100vh - 163px)`}}>
                {child}
            </TabPanel>
        )
    })

    const loadingWrapper = <div className={classes.center}><CircularProgress color='secondary'/></div>

    useEffect(() => {
        if(props.position === 'left') {
            if(props.usageFor === 'local_delivery') {
                if(isHidden) {
                    setWidthValue('35px');
                } else {
                    setWidthValue('550px');
                }
            } else {
                if(isHidden) {
                    setWidthValue('35px');
                } else {
                    setWidthValue('350px');
                } 
            }
        } else {
            if(isHidden) {
                setWidthValue('55px');
            } else {
                setWidthValue('550px');
            }
        }
    }, [isHidden, props.position])

    return (
        <div className={`${props.containerStyle}`} 
            style={{
                width: widthValue
                //pointerEvents: props.disabled ? "none" : "initial"  
            }}
        >
            <div className={`${classes.container} ${toggleButtonStyles.direction}`}>
                <Paper 
                    style={{
                        height: '100%', 
                        justifyContent: 'flex-start', 
                        display: 'flex', 
                        flexDirection: 'column'
                    }} 
                    style={isHidden ? {
                        width: '0%',
                        transition: '0.3s',
                        overflow: 'hidden'
                    } : {
                        width: '100%',
                        transition: '0.3s',
                        overflow: 'hidden'
                    }}
                    elevation={1}
                >
                    {
                        props.disabled ?
                        <div className={classes.disabled} style={{
                            position:'absolute', 
                            width: '90%', 
                            height: '100%'
                        }}>
                            <div style={{textAlign: 'center', padding: 16}}>
                                <Lock style={{fontSize: 40}}/>
                                <div style={{width: '100%'}}>
                                    <Typography variant='h6'>{t('panel_locked')}</Typography>
                                    <Typography>{props.disableMessage}</Typography>
                                </div>
                            </div>
                        </div>
                        :
                        null
                    }
                    {props.headerComponent}
                    {props.headerComponent && <Divider/>}
                    {props.isContentLoading ? loadingWrapper : childrenWithWrapper}
                </Paper>
                <div style={{width: 35, height: '100%', flexDirection: 'column'}}>
                    <Paper className={`${classes.tab} ${toggleButtonStyles.cornerStyle}`} style={{marginBottom: 20}} elevation={0}>
                        <div className={classes.innerTab} onClick={()=>setIsHidden(!isHidden)}>
                            {isHidden ? toggleButtonStyles.hide : toggleButtonStyles.show}
                        </div>
                    </Paper>
                    {props.tabs.map((tab, index) => (
                        <Paper 
                        key={index} 
                        className={`${classes.tab} ${toggleButtonStyles.cornerStyle}`} 
                        elevation={0}
                        style={{
                            backgroundColor: tab.value === tabValue ? '' : 'GrayText',
                            pointerEvents: props.disabled ? "none" : "initial",
                            cursor: 'pointer'
                        }}>
                            <div
                                className={classes.innerTab} 
                                style={{writingMode: toggleButtonStyles.writingMode}} 
                                onClick={()=>setTabValue(tab.value)}
                            >
                                <Typography>{tab.label}</Typography>
                            </div>
                        </Paper>
                    ))}
                </div>
            </div>
        </div>
    )

    function getToggleButtonStyle(position){
        switch(position){
            case 'right':
                return {
                    cornerStyle: classes.noRightCornerRadius,
                    direction: classes.rightDirection,
                    writingMode: 'vertical-rl',
                    hide: <ChevronLeft style={{cursor:'pointer'}}/>,
                    show: <ChevronRight style={{cursor:'pointer'}}/>
                }
            default:
                return {
                    cornerStyle: classes.noLeftCornerRadius,
                    direction: classes.leftDirection,
                    writingMode: 'vertical-lr',
                    hide: <ChevronRight style={{cursor:'pointer'}}/>,
                    show: <ChevronLeft style={{cursor:'pointer'}}/>
                }
        } 
    }

    function togglePanelVisibility(){
        switch(isHidden){
            case false:

                break;
        }
    }
}

HideablePanel.defaultProps = {
    tabs: [],
    isContentLoading: false,
    disabled: false,
    disableMessage: ""
}

export default HideablePanel